export const productErrorCode: Record<string, string> = Object.freeze({
  error_code_2: "SKU doesn't exist or was not read correctly",
  sku_discontinued: "SKU is discontinued",
  country_not_supported: "Country not supported",
} as const);
